import { createContext } from "react";
import type { RoutingScene } from "@/lib/cable-router/types";
import type { TerminalSide } from "@/lib/types";

export type ConnectionPreview = {
  nodeId: string;
  terminalId: string;
  point: { x: number; y: number };
  side: TerminalSide;
};

export const ConnectionPreviewContext = createContext<ConnectionPreview | null>(null);

export const RoutingSceneContext = createContext<RoutingScene | undefined>(undefined);
